module.exports = __webpack_public_path__ + "img/pic.723b3db2.svg";